import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import img from '../../images/dott.jpg'
import { Link } from "react-router-dom";
import webDimg from '../../images/Website Development & Designing/Best-website-development-companies.png'
import mobiDimg from '../../images/MOBILE APP DEVELOPMENT/Mobile-App-Development.png'
import contentImg from '../../images/CONTENT WRITING/Content-Writing.png'
import digitalImg from '../../images/DIGITAL MARKETING/Digital-Marketing.png'
import webHImg from '../../images/WEB HOSTING SERVICE/Web-Hosting.png'
import webDesignerImg from '../../images/WEB DESIGNING/Web-Designing.png'
import GraphicImg from '../../images/GRAPHIC DESIGNING/Graphic-Designing.png'
import socialMediaImg from '../../images/SOCIAL MEDIA MARKETING/SOCIAL-MEDIA-MARKETING.png'

function Service_list() {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    let Services_list = [
        {
            hadding: "WEBSITE DEVELOPMENT",
            href: "/WebsiteDevelopmentDesigning",
            p: "Our expert developers build fast, responsive, and visually appealing websites using the latest technologies. Whether it’s front-end design or back-end functionality, we ensure your website delivers outstanding performance and user experience across all devices and browsers.",
            img: webDimg
        },
        {
            hadding: "MOBILE APP DEVELOPMENT",
            href: "/MobileApplicationDevelopment",
            p: "From initial concept to final launch, our mobile application development services cover every stage of the process. We analyze your goals, target audience, and technical needs to build custom mobile solutions that are scalable, secure, and impactful — ensuring a strong mobile presence for your brand.",
            img: mobiDimg
        },
        {
            hadding: "CONTENT WRITING",
            href: "/ContentWriting",
            p: "Our skilled content creators deliver engaging, SEO-optimized content tailored to your brand’s tone and audience. From website copy to blogs and marketing materials, we help you communicate clearly, build trust, and drive more traffic and conversions.",
            img: contentImg
        },
        {
            hadding: "SOCIAL MEDIA MARKETING",
            href: "/SocialMediaMarketing",
            p: "We craft compelling social media strategies that elevate your brand across platforms like Facebook, Instagram, LinkedIn, and other key platforms. Our team handles content creation, posting schedules, engagement, and analytics — helping you grow your community and influence.",
            img: socialMediaImg
        },
        {
            hadding: "Digital Marketing",
            href: "/DigitalMarketing",
            p: "Our full-spectrum digital marketing services include SEO, PPC, email marketing, and other key platforms. We develop data-driven strategies that increase your online visibility, attract quality leads, and improve ROI — putting your brand at the forefront of your industry.",
            img: digitalImg
        },
        {
            hadding: "WEB HOSTING SERVICES",
            href: "/WebHostingServices",
            p: "Ensure reliable and secure online operations with our web hosting solutions. We provide scalable, high-speed, and secure hosting environments tailored to your needs, including domain management, uptime monitoring, and regular backups.",
            img: webHImg
        },
        {
            hadding: "Web Designing",
            href: "/WebDesign",
            p: "Our creative design team delivers sleek, modern, and user-centric web designs that leave lasting impressions. We focus on usability, responsiveness, and brand alignment to provide interfaces that are both functional and aesthetically pleasing.",
            img: webDesignerImg
        },
        {
            hadding: "Graphic Design",
            href: "/GraphicDesign",
            p: "From logos and brochures to banners and ad creatives, our graphic design services enhance your brand’s visual identity. We create professional, impactful designs that reflect your values and resonate with your target audience.",
            img: GraphicImg
        },
    ]

    return (
        <div className='bg_dott my-5' style={{ backgroundImage: `url(${img})` }} >
            <Container className='py-3'>
                <Row className='d-flex justify-content-center'>
                    <Col xl={12} md={10}>
                        <div className='text-center mb-5'>
                            <span className='text-base fs-1 fw-bold'>SERVICES </span>
                            <p>Our experienced professionals work closely with you to understand your business goals and challenges. We evaluate your current digital infrastructure, identify areas of improvement, and develop a strategic roadmap that integrates advanced technology with your long-term business objectives.</p>
                        </div>
                        <Row className='justify-content-center'>
                            {Services_list.map((el, i) => {
                                return (
                                    <Col lg={4} md={6} sm={6} className='mb-4 d-flex align-items-stretch' key={i}>
                                        <div className="card border-0 shadow rounded">
                                            <div className="card-img-top">
                                                <img src={el.img} style={{ height: "270px", width: "100%" }} className='rounded' alt="" />
                                            </div>
                                            <div className="card-body">
                                                <Link style={{ textDecoration: 'none' }} onClick={scrollToTop} to={el.href}>
                                                    <span className='text-primary-base fw-semibold fs-5'>{el.hadding}</span>
                                                </Link>
                                                <p className='text-base mt-2'>{el.p}</p>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}

                        </Row>
                    </Col>
                </Row>

            </Container>
        </div>
    )
}

export default Service_list